export default __webpack_public_path__ + "static/media/burningskull.59026f13.png";